import { RootState } from '../../../redux/store';

export interface NotificationBannerDerivationInput {
    isBannerDismissed: boolean;
    now?: number;
}

export interface NotificationBannerState {
    shouldShowBanner: boolean;
    shouldAutoOpenDialog: boolean;
}

export const deriveNotificationBannerState = (
    state: RootState,
    input: NotificationBannerDerivationInput,
): NotificationBannerState => {
    const activeUserInfo = state.app.activeUserInfo;
    const bannerConfig = state.notificationBanner.bannerConfig;
    const now = input.now ?? Date.now();

    const startDate = bannerConfig?.startDate;
    const endDate = bannerConfig?.endDate;
    const startTimestamp = startDate ? new Date(startDate).getTime() : null;
    const endTimestamp = endDate ? new Date(endDate).getTime() : null;

    const isWithinDateRange =
        startTimestamp !== null && endTimestamp !== null && startTimestamp <= now && endTimestamp >= now;

    const shouldShowBanner =
        Boolean(activeUserInfo) &&
        !input.isBannerDismissed &&
        typeof bannerConfig?.bannerMessage === 'string' &&
        isWithinDateRange;

    const shouldAutoOpenDialog =
        shouldShowBanner &&
        bannerConfig?.showDialog === 'true' &&
        Array.isArray(bannerConfig?.features) &&
        bannerConfig.features.length > 0;

    return {
        shouldShowBanner,
        shouldAutoOpenDialog,
    };
};

export default deriveNotificationBannerState;